import { ClientsPageLayout } from './pageLayout';

type Props = {
  subpage: 'requests' | 'agencies' | 'facilities';
};
export function Component(params: Props) {
  return <ClientsPageLayout activeTab={params.subpage}/>;
}
